export default {
    plugins: ['animate'],
}


// WEBPACK FOOTER //
// ./src/config/plugin.js